//
// Copyright IBM Corp. 2020, 2021
//
// This source code is licensed under the Apache-2.0 license found in the
// LICENSE file in the root directory of this source tree.
//
export var isProduction = process.env.NODE_ENV === 'production';
export var noop = function noop() {
  return undefined;
};
export var shimIfProduction = function shimIfProduction(fn) {
  return isProduction ? noop : fn;
};
export var log = shimIfProduction(function () {
  var _console;

  return (_console = console).log.apply(_console, arguments);
});
export var warn = shimIfProduction(function () {
  var _console2;

  return (_console2 = console).warn.apply(_console2, arguments);
});
export var error = shimIfProduction(function () {
  var _console3;

  return (_console3 = console).error.apply(_console3, arguments);
});
export default {
  isProduction: isProduction,
  noop: noop,
  shimIfProduction: shimIfProduction,
  log: log,
  warn: warn,
  error: error
};